import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute'
import Layout from '../components/layout'
import { MobileMenu } from '../Pages/MobileMenu/page'

export const MobileMenuRoutes = ({ menuActive, setMenuActive }) => (
    <>
        <Route path="/mobileMenu" element={
            <ProtectedRoute>
                <Layout activePage='mobileMenu' menuActive={menuActive} setMenuActive={setMenuActive}>
                    <MobileMenu />
                </Layout>
            </ProtectedRoute>
        } />
    </>
);
